const extractGlobalProperties = (app) => app.config.globalProperties;
const defineGlobalProperty = (app, key, v) => {
  const globalProperties = extractGlobalProperties(app);
  globalProperties[key] = v;
};
const getGlobalProperty = (app, key) => {
  return extractGlobalProperties(app)[key];
};
export { defineGlobalProperty as d, getGlobalProperty as g };
//# sourceMappingURL=global-properties.js.map
